import { createSlice } from "@reduxjs/toolkit";
import { getProfileData} from "../services/profile-services";
const initialState = {
  profiles: [],
  profile: null,
  error: [],
  loading: false,
  responseMessage: null,
  success: false,
  successMessage: null,
  deleteResponse: false,
  errorMessage: null,
};

export const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    resetUser(state){
      state.responseMessage = null;

    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProfileData.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getProfileData.fulfilled, (state, action) => {
        state.profile = action.payload.data.item;
        state.loading = false;
      })
      .addCase(getProfileData.rejected, (state, action) => {
        state.loading = false;
      });

  },
});

export const error = (state) => state.error;
export const loading = (state) => state.loading;
export const deleteResponse = (state) => state.deleteResponse;
export default profileSlice.reducer;
